// Validate the native Releasit form before it creates an order.
(function () {
  function coverage(form, report) {
    const province = form.querySelector('#province_country_field');
    const postcode = form.querySelector('#zip_code');
    if (!province || !postcode) return true;
    const prefix = { CA: '11', MA: '29', 'Cádiz': '11', Cadiz: '11', 'Málaga': '29', Malaga: '29' }[province.value];
    province.setCustomValidity(prefix ? '' : 'Solo entregamos en las provincias de Cádiz y Málaga.');
    const valid = prefix && new RegExp('^' + prefix + '\\d{3}$').test(postcode.value.trim());
    postcode.setCustomValidity(valid ? '' : 'El código postal debe tener cinco cifras y corresponder a la provincia: Cádiz (11) o Málaga (29).');
    postcode.inputMode = 'numeric';
    postcode.autocomplete = 'postal-code';
    postcode.maxLength = 5;
    if (report && !province.checkValidity()) { province.reportValidity(); return false; }
    if (report && !postcode.checkValidity()) { postcode.reportValidity(); return false; }
    return !!valid;
  }
  ['input', 'change'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      if (!event.target.matches('#province_country_field, #zip_code')) return;
      const form = event.target.closest('form._rsi_main_form_element');
      if (form) coverage(form, false);
    }, true);
  });
  document.addEventListener('click', function (event) {
    const button = event.target.closest('button.rsi-submit_button');
    if (button && button.form && !coverage(button.form, true)) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.target.matches('form._rsi_main_form_element') && !coverage(event.target, true)) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
}());

(function () {
  const forms = new WeakMap();
  const choices = new WeakMap();
  const source = document.querySelector('[data-dp-size-placeholder]');
  if (!source) return;
  const placeholder = source.dataset.dpSizePlaceholder;
  const error = source.dataset.dpSizeError;
  function reconcile(form) {
    if (form.dataset.open === 'false' || !form.querySelector('select.rsi-variant-picker-select')) { forms.delete(form); return; }
    const pack = form.querySelector('[id^="quantity_offer_"]:checked');
    const packId = pack ? pack.id : 'single';
    let state = forms.get(form);
    if (!state || state.pack !== packId) {
      state = { pack: packId, tokens: [] };
      forms.set(form, state);
    }
    const unused = state.tokens.slice();
    form.querySelectorAll('select.rsi-variant-picker-select').forEach(function (select, index) {
      if (select.disabled || !select.options.length) return;
      let choice = choices.get(select);
      if (!choice || choice.state !== state) choice = { state: state, nativeValue: select.value, token: null };
      if (select.value) choice.nativeValue = select.value;
      const tokenIndex = unused.findIndex(function (token) { return token.value === choice.nativeValue; });
      choice.token = tokenIndex < 0 ? null : unused.splice(tokenIndex, 1)[0];
      choices.set(select, choice);
      select.required = true;
      select.setAttribute('aria-label', 'Talla ' + (index + 1));
      let prompt = select.querySelector('option[data-dp-size-prompt]');
      if (!prompt) {
        prompt = document.createElement('option');
        prompt.value = choice.nativeValue;
        prompt.textContent = placeholder;
        prompt.disabled = true;
        prompt.dataset.dpSizePrompt = '';
        select.prepend(prompt);
      }
      if (choice.token) {
        select.selectedIndex = Array.from(select.options).findIndex(function (option) { return !option.hasAttribute('data-dp-size-prompt') && option.value === choice.token.value; });
        select.setCustomValidity('');
      } else {
        prompt.value = choice.nativeValue;
        prompt.selected = true;
        select.setCustomValidity(error);
      }
    });
    return state;
  }
  document.addEventListener('change', function (event) {
    const select = event.target.closest('select.rsi-variant-picker-select');
    const form = select && select.closest('form._rsi_main_form_element');
    if (!form || !select.value) return;
    const state = forms.get(form);
    if (!state) return;
    const choice = choices.get(select);
    if (choice && choice.token && state.tokens.includes(choice.token)) choice.token.value = select.value;
    else state.tokens.push({ value: select.value });
    if (choice) choice.nativeValue = select.value;
    select.setCustomValidity('');
  }, true);
  function validate(form) {
    reconcile(form);
    const selects = Array.from(form.querySelectorAll('select.rsi-variant-picker-select'));
    const invalid = selects.find(function (select) { return select.disabled || !choices.get(select) || !choices.get(select).token || !select.checkValidity(); });
    if (!selects.length) return false;
    if (invalid) { if (!invalid.disabled) invalid.reportValidity(); return false; }
    return true;
  }
  document.addEventListener('click', function (event) {
    const button = event.target.closest('button.rsi-submit_button');
    if (button && button.form && !validate(button.form)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.target.matches('form._rsi_main_form_element') && !validate(event.target)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  const observer = new MutationObserver(function (mutations) {
    if (!mutations.some(function (mutation) { return mutation.type === 'childList' || mutation.attributeName === 'disabled' || mutation.attributeName === 'data-open'; })) return;
    document.querySelectorAll('form._rsi_main_form_element').forEach(reconcile);
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'data-open'] });
  document.querySelectorAll('form._rsi_main_form_element').forEach(reconcile);
}());

(function () {
  let pending = false;
  function refreshCount() {
    if (pending) return;
    pending = true;
    const link = document.querySelector('.dp-cart-link');
    if (!link) { pending = false; return; }
    fetch(link.pathname.replace(/cart\/?$/, 'cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('cart'); return response.json(); })
      .then(function (cart) { document.querySelectorAll('[data-dp-cart-count]').forEach(function (element) { element.textContent = cart.item_count; }); })
      .catch(function () {})
      .finally(function () { pending = false; });
  }
  window.addEventListener('pageshow', refreshCount);
  window.addEventListener('focus', refreshCount);
  ['cart:updated', 'cart:refresh'].forEach(function (name) { document.addEventListener(name, refreshCount); });
}());
